/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ChatByFormReceivingKind {
    Locations = 1,
    FixedFunction = 2,
}
